export function isAuthError(e: unknown): boolean {
  if (typeof e !== 'object' || !e) return false;
  const { status, code, name, title } = e as Record<string, unknown>;
  if (status === '401' || status === 401) return true;
  const codeOrName = [code, name, title].filter((v): v is string => typeof v === 'string');
  return codeOrName.some((s) => s.includes('NotAuthorized'));
}
